/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2022-01-19 11:28:54
 * @LastEditors: 廖图图
 * @LastEditTime: 2022-01-19 17:04:23
 */
import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 视图
 */
const workOrder = {
  createNewAddressInfoAndSetPri(params) {
    return axios.post(
      base.workOrder.createNewAddressInfoAndSetPri,
      utils.postParamsArrayToJsonString(params)
    );
  },
  listCustomerAddress(params) {
    return axios.post(
      base.workOrder.listCustomerAddress,
      utils.postParamsArrayToJsonString(params)
    );
  },
  listMyCustomer(params) {
    return axios.post(
      base.workOrder.listMyCustomer,
      utils.postParamsArrayToJsonString(params)
    );
  },
  modifyNewAddressInfo(params) {
    return axios.post(
      base.workOrder.modifyNewAddressInfo,
      utils.postParamsArrayToJsonString(params)
    );
  },
  removeNewAddressInfo(params) {
    return axios.post(
      base.workOrder.removeNewAddressInfo,
      utils.postParamsArrayToJsonString(params)
    );
  },
  listServiceRegionByCompanyId(params) {
    return axios.post(
      base.workOrder.listServiceRegionByCompanyId,
      utils.postParamsArrayToJsonString(params)
    );
  },
  listElectricOperationsWorkBases(params) {
    return axios.post(
      base.workOrder.listElectricOperationsWorkBases,
      utils.postParamsArrayToJsonString(params)
    );
  },

  createUser(params) {
    return axios.post(
      base.workOrder.createUser,
      utils.postParamsArrayToJsonString(params)
    );
  },
};

export default workOrder;
